import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { FcpSummaryBarModule } from 'fc-ui-components';

import { MainNavigationSummaryBarComponent } from 'src/app/components/main-navigation/main-navigation-summary-bar/main-navigation-summary-bar.component';

@NgModule({
    declarations: [MainNavigationSummaryBarComponent],
    imports: [CommonModule, TranslateModule, FcpSummaryBarModule],
    exports: [MainNavigationSummaryBarComponent]
})
export class MainNavigationSummaryBarModule {}
